module.exports = __webpack_public_path__ + "img/frontend_base_energy.1b50e5e4.jpg";